import { ref } from 'vue'

const STORAGE_KEY = 'show_cms_hints'

// Two things at once. The read runs on import, which during a server render
// means Node: there is no localStorage there, and the unguarded read threw a
// ReferenceError that failed the whole module — taking every CMS component
// that imports this composable (CmsBlock, CmsBlockRecursive, CmsVariable,
// CmsHint) down with it, so those blocks server-rendered empty. The server has
// no stored preference to read anyway; it starts with hints off and the client
// reads the real value when the module loads there. And the preference is
// presence, not a stored 0/1: localStorage.setItem(key, 0) reads back as the
// truthy string "0", which left the hints on after toggling them off and
// reloading.
const showCmsHints = ref(
  import.meta.env.SSR ? false : !!localStorage.getItem(STORAGE_KEY)
)

const useHint = () => {
  const toggle = () => {
    if (typeof window === 'undefined') {
      console.warn('window is undefined')
      return
    }
    showCmsHints.value = !showCmsHints.value
    showCmsHints.value
      ? localStorage.setItem(STORAGE_KEY, 'true')
      : localStorage.removeItem(STORAGE_KEY)
  }

  return { showCmsHints, toggle }
}

export { useHint }
